import React, { useState } from 'react';
import {
    TextField, Typography, RadioGroup, FormControlLabel, Radio,
    FormControl, IconButton, Popover, Box, Button
} from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { LocalizationProvider, DateCalendar, PickersDay } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import '../Pages/RegisterForm.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import DatePickerCalendar from '../components/DatePickerCalendar';

const theme = createTheme({
  direction: 'rtl',
  typography: {
    fontFamily: 'Varela Round, sans-serif',
  },
});

export default function GoogleLoginStep({ formData, setFormData, onNext }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const [errors, setErrors] = useState({
        title: false,
        phoneNumber: false,
        gender: false,
        birthDate: false,
    });

    const handleContinue = () => {
        const travelPitchText = formData.travelPitch?.trim() || '';
        const wordCount = travelPitchText === '' ? 0 : travelPitchText.split(/\s+/).length;

        const newErrors = {
            title: !formData.title,
            phoneNumber: !formData.phoneNumber,
            gender: !formData.gender,
            birthDate: !formData.birthDate,
            travelPitch: travelPitchText === '' || wordCount > 5
        };

        setErrors(newErrors);

        const hasErrors = Object.values(newErrors).some(Boolean);
        if (!hasErrors) {
            onNext();
        }
    };




    return (
        <ThemeProvider theme={theme}>
            <Box>
                <Typography className="register-title">כמה פרטים עליך</Typography>

                <TextField
                    required
                    label="שם מלא"
                    fullWidth
                    margin="normal"
                    value={formData.title || ''}
                    error={errors.title}
                    onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                />

                <TextField
                    required
                    label="טלפון"
                    fullWidth
                    margin="normal"
                    value={formData.phoneNumber || ''}
                    error={errors.phoneNumber}
                    onChange={(e) => setFormData({ ...formData, phoneNumber: e.target.value })}
                />

                <FormControl fullWidth margin="normal">
                    <Typography
                        variant="subtitle1"
                        sx={{ mb: 1, color: errors.gender ? 'red' : 'black' }}
                    >
                        מגדר <span>*</span>
                    </Typography>

                    <RadioGroup
                        row
                        value={formData.gender || ''}
                        onChange={(e) => setFormData({ ...formData, gender: e.target.value })}
                    >
                        <FormControlLabel value="זכר" control={<Radio />} label="זכר" />
                        <FormControlLabel value="נקבה" control={<Radio />} label="נקבה" />
                        <FormControlLabel value="אחר" control={<Radio />} label="אחר" />
                    </RadioGroup>

                    {errors.gender && (
                        <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                            יש לבחור מגדר
                        </Typography>
                    )}
                </FormControl>

                {/* Birth Date Picker */}
                <DatePickerCalendar
                    value={formData.birthDate || ''}
                    onChange={(date) => setFormData({ ...formData, birthDate: date })}
                    label="תאריך לידה"
                    required
                    error={errors.birthDate}
                    helperText={errors.birthDate ? 'יש לבחור תאריך לידה' : ''}
                    disablePortal={false}
                    popoverZIndex={2000}
                />

                <TextField
                    required
                    label="כדאי לטייל איתי כי"
                    fullWidth
                    margin="normal"
                    inputProps={{ maxLength: 60, dir: 'rtl' }}
                    helperText={errors.travelPitch ? 'יש למלא תשובה קצרה עד 5 מילים' : 'עד 5 מילים'}
                    error={errors.travelPitch}
                    value={formData.travelPitch || ''}
                    onChange={(e) => setFormData({ ...formData, travelPitch: e.target.value })}
                />


                <Button
                    className="register-button"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 2 }}
                    onClick={handleContinue}
                >
                    המשך
                </Button>
            </Box>
        </ThemeProvider>
    );
}
